<template>
  <div>
    <div class="row">
      <div
        class="col-12"
        style="
          font-family: deinebaustoffesecondary;
          text-align: center;
          font-size: 2rem;
          margin: 20px 0px 30px 0px;
        "
      >
        DEBUG-O-MAT
      </div>
    </div>
    <div class="row" style="margin-bottom: 20px;">
      <div class="col-4">Breite:</div>
      <div class="col-8">
        <input type="number" v-model="width" @change="update()" />
      </div>
    </div>
    <div class="row" style="margin-bottom: 20px;">
      <div class="col-4">Höhe:</div>
      <div class="col-8">
        <input type="number" v-model="height" @change="update()" />
      </div>
    </div>
    <div class="row" style="margin-bottom: 20px;">
      <div class="col-4">Gestänge:</div>
      <div class="col-8">
        <input
          type="radio"
          name="thickness"
          value="50"
          v-model="thickness"
          @change="update()"
        />
        50
        <input
          type="radio"
          name="thickness"
          value="75"
          v-model="thickness"
          @change="update()"
        />
        75
        <input
          type="radio"
          name="thickness"
          value="100"
          v-model="thickness"
          @change="update()"
        />
        100
      </div>
    </div>
    <div class="row" style="margin-bottom: 20px;">
      <div class="col-4">Beplankung:</div>
      <div class="col-8">
        <input
          type="radio"
          name="planking"
          value="1"
          v-model="planking"
          @change="update()"
        />
        Einzel
        <input
          type="radio"
          name="planking"
          value="2"
          v-model="planking"
          @change="update()"
        />
        Doppel
      </div>
    </div>
    <div class="row" style="margin-bottom: 20px;">
      <div class="col-4">Dämmstoff:</div>
      <div class="col-8">
        <input
          type="radio"
          name="daemstoff"
          value="glaswolle"
          v-model="daemstoff"
          @change="update()"
        />
        Glaswolle
        <input
          type="radio"
          name="daemstoff"
          value="steinwolle"
          v-model="daemstoff"
          @change="update()"
        />
        Steinwolle
      </div>
    </div>
    <div class="row" style="margin-bottom: 20px;">
      <div class="col-4">Dämmstoff:</div>
      <div class="col-8">
        <input
          type="radio"
          name="coveringplates"
          value="gipsfaserplatten"
          v-model="coveringplates"
          @change="update()"
        />
        Gipsfaserplatten
        <input
          type="radio"
          name="coveringplates"
          value="gipskartonplatten"
          v-model="coveringplates"
          @change="update()"
        />
        Gipskartonplatten
      </div>
    </div>
    <div class="row" style="margin-bottom: 20px;">
      <div class="col-4">Türen:</div>
      <div class="col-8">
        <select name="doors" value="1" v-model="doors" @change="update()">
          <option value="0">0</option>
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
          <option value="5">5</option>
          <option value="6">6</option>
          <option value="7">7</option>
          <option value="8">8</option>
          <option value="9">9</option>
          <option value="10">10</option>
        </select>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      width:
        this.$store.state.results.ask_width > 0
          ? this.$store.state.results.ask_width
          : 1000,
      height:
        this.$store.state.results.ask_height > 0
          ? this.$store.state.results.ask_height
          : 260,
      thickness:
        this.$store.state.results.ask_thickness > 0
          ? this.$store.state.results.ask_thickness
          : 1,
      planking:
        this.$store.state.results.ask_planking > 0
          ? this.$store.state.results.ask_planking
          : 1,
      coveringplates:
        this.$store.state.results.coveringplates.length > 0
          ? this.$store.state.results.coveringplates
          : "gipsfaserplatten",
      daemstoff:
        this.$store.state.results.daemmstoff.length > 0
          ? this.$store.state.results.daemmstoff
          : "glaswolle",
      doors:
        this.$store.state.results.ask_door === undefined
          ? this.$store.state.results.ask_door
          : 0,
    };
  },

  computed: {
    /*
      width() {
          return this.$store.state.results.ask_width > 0 ? this.$store.state.results.ask_width : 600;
      },

      height() {
          return this.$store.state.results.ask_height > 0 ? this.$store.state.results.ask_height : 260;
      },

      thickness() {
          return this.$store.state.results.ask_thickness > 0 ? this.$store.state.results.ask_thickness : 50;
      },

      planking() {
          return this.$store.state.results.ask_planking > 0 ? this.$store.state.results.ask_planking : 1;
      },

      coveringplates() {
          return this.$store.state.results.coveringplates.length > 0 ? this.$store.state.results.coveringplates : "gipsfaserplatten";
      },

      daemstoff() {
          return this.$store.state.results.daemmstoff.length > 0 ? this.$store.state.results.daemmstoff : "glaswolle";
      },

      doors() {
          return this.$store.state.results.ask_door > 0 ? this.$store.state.results.ask_door : 1;
      }*/
  },

  create() {
    /*
        this.width = this.$store.state.results.ask_width > 0 ? this.$store.state.results.ask_width : 600;
        this.height = this.$store.state.results.ask_height > 0 ? this.$store.state.results.ask_height : 260;
        this.thickness = this.$store.state.results.ask_thickness > 0 ? this.$store.state.results.ask_thickness : 50;
        this.planking = this.$store.state.results.ask_planking > 0 ? this.$store.state.results.ask_planking : 1;
        this.coveringplates = this.$store.state.results.coveringplates.length > 0 ? this.$store.state.results.coveringplates : "gipsfaserplatten";
        this.daemmstoff = this.$store.state.results.daemmstoff.length > 0 ? this.$store.state.results.daemmstoff : "glaswolle";
        this.doors = this.$store.state.results.ask_door > 0 ? this.$store.state.results.ask_door : 1;
*/
    this.update();
  },

  methods: {
    update() {
      let self = this;

      console.log("DEBUG");

      this.$parent.$store.commit("setResults", {
        ask_width: self.width,
        ask_height: self.height,
        ask_thickness: self.thickness,
        ask_planking: self.planking,
        ask_door: self.doors,
        daemmstoff: self.daemstoff,
        coveringplates: self.coveringplates,
      });

      this.$parent.updateProducts();
    },
  },
};
</script>
